<template>
  <v-layout row wrap class="colored-background">
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <img width="52%" :src="assetRoot + 'musicplus.png'" />
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-4 text-xs-center">
      <span class="seven-days-free">4 FREE APPS</span>
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-3">
      <v-layout row wrap v-for="item in listItems">
        <v-spacer />
        <v-flex xs1 sm1 md1>
          <center>
          <v-img width="1.0rem" :src="assetRoot + 'check.png'" />
        </center>
        </v-flex>
        <v-flex xs8 sm8 md8>
          <span class="list-item-text">{{ item }}</span>
        </v-flex>
        <v-spacer />
      </v-layout>
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-4 text-xs-center">
      <img width="70%" :src="assetRoot + 'group-9.png'" />
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-4 text-xs-center">
      <span class="create-account">Create an account <span class="to-start">to start:</span></span>
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-4 text-xs-center">
      <register-card-simple register_key="top" />
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <span class="what-you-get">What you get</span>
    </v-flex>
    <v-flex xs12 sm12 md12 v-for="app in appsListItems" class="mt-4 ">
      <v-layout column align-center>
        <v-flex class="my-2">
          <v-img width="58" :src="assetRoot + app.icon" />
        </v-flex>
        <v-flex class="my-2">
          <span class="app-title">{{app.title}}</span>
        </v-flex>
        <v-flex class="my-2">
          <img width="100%" :src="assetRoot + app.image" />
        </v-flex>
        <v-flex class="app-text px-5 my-2">
          <span>{{app.text}}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <div class="create-account">Create an account <span class="to-start">to start</span></div>
      <div class="create-account-to-start">using the apps:</div>
    </v-flex>
    <v-flex xs12 sm12 md12 class="my-4 text-xs-center">
      <register-card-simple register_key="bottom" />
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  import RegisterCard from './RegisterCard'
  import RegisterCardSimple from './RegisterCardSimple'

  const moment = require('moment')

  export default {
    components: {
      'register-card': RegisterCard,
      'register-card-simple': RegisterCardSimple
    },
    data: () => ({
      listItems: ['Music apps to learn music', 'Thousands of songs & lessons', 'Easy step-by-step tutorials'],

      appsListItems: [
        { icon: 'icon-guitar.png', title: 'GUITAR LESSONS', image: 'pic-guitar.png', text: 'Playing the guitar has never been that easy ! Pick your favorite guitar, choose among thousands of songs your lesson and become a guitar master in no time.' },
        { icon: 'icon-piano.png', title: 'PIANO LESSONS', image: 'pic-piano.png', text: 'Learn how to play the piano like a pro. Choose your favorite keyboard, pick among thousands of piano classics your lesson of the day and start to play !' },
        { icon: 'icon-drums.png', title: 'DRUMS LESSONS', image: 'pic-drums.png', text: 'Feel like you\'re playing on a real drum set. Wether you are a beginner or a pro dummer, pick your song, practice, and improve your drumming skills in no time !' },
        { icon: 'icon-bmp.png', title: 'BEATMAKING LESSONS', image: 'pic-bmp.png', text: 'The easiest way to master the art of beat-making. Easy tutorials for a quick learning, and thousands of sounds available for unlimited possibilites. Super easy, super fun !' },
      ]
    }),
    methods: {
      handleScroll (event) {
        if (this.$session.exists(this.scrolled1000StorageKey) && this.$session.exists(this.scrolled2000StorageKey) && this.$session.exists(this.scrolled3000StorageKey)) {
          return
        }

        if (window.scrollY > 1000) {
          if (!this.$session.exists(this.scrolled1000StorageKey)) {
            this.$session.set(this.scrolled1000StorageKey, true);
            this.sendEvent('scroll_target_reached', '1000')
          }
        }

        if (this.$session.exists(this.scrolled2000StorageKey) && this.$session.exists(this.scrolled3000StorageKey)) {
          return
        }

        if (window.scrollY > 2000) {
          if (!this.$session.exists(this.scrolled2000StorageKey)) {
            this.$session.set(this.scrolled2000StorageKey, true);
            this.sendEvent('scroll_target_reached', '2000')
          }
        }

        if (this.$session.exists(this.scrolled3000StorageKey)) {
          return
        }

        if (window.scrollY > 3000) {
          if (!this.$session.exists(this.scrolled3000StorageKey)) {
            this.$session.set(this.scrolled3000StorageKey, true);
            this.sendEvent('scroll_target_reached', '3000')
          }
        }
      },
      sendEvent (type, value) {
        let payload = {
          env: this.env,
          headers: { appKey: this.appKey, offer: this.offer, version: this.version },
          body: {
            session_id: this.sessionId,
            layout_id: this.layoutId,
            user_instance_id: this.userInstanceId,
            type: type,
            value: value,
          }
        }
        this.$store.dispatch('EVENT_SEND', payload)
      }
    },
    computed: {
      ...mapGetters([
        'env',

        'location',
        'assetRoot',

        'appKey',
        'offer',
        'version',
        'userInstanceId',
        'sessionId',
        'layoutId',

        'scrolled1000StorageKey',
        'scrolled2000StorageKey',
        'scrolled3000StorageKey',
      ])
    },
    mounted () {
      this.$nextTick(function () {

      })
    },
    watch: {

    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>

<style scoped>
  .colored-background {
    background-size: contain;
    background-image:url('https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/BG-opti.jpg');
    background-color: #05151F;
  }

  .seven-days-free {
    font-family: CenturyGothic;
    font-size: 2.4rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.86;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  .list-item-text {
    font-family: CenturyGothic;
    font-size: 1rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    color: #ffffff;
  }

  .create-account {
    font-family: CenturyGothic;
    font-size: 1.4rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  .create-account .to-start {
    font-weight: normal;
  }

  .create-account-to-start {
    font-family: CenturyGothic;
    font-size: 1.3rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  .what-you-get {
    font-family: CenturyGothic;
    font-size: 2.4rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  .app-title {
    font-family: CenturyGothic;
    font-size: 1.7rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  .app-text {
    font-family: CenturyGothic;
    font-size: 1.3rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: justify;
    color: #ffffff;
  }
</style>
